const airOrderRoutes = [
  {
    path: "/air-order/detail/:id",
    name: "AirOrderDetail",
    component: () => import("./detail/index.vue"),
    meta: {
      title: "空运订单详情",
      keepHomeLayout: true,
    },
    hidden: true,
  },
  {
    path: "/air-order/add",
    name: "AirOrderAdd",
    component: () => import("./add/index.vue"),
    meta: {
      title: "空运订单新增",
      keepHomeLayout: true,
    },
    hidden: true,
  },
];

export default airOrderRoutes;
